<!--
 * @Author: wumao
 * @Date: 2021-11-25 16:31:58
 * @LastEditors: wumao
 * @LastEditTime: 2021-11-30 15:29:15
 * @Description:
-->
<template>
  <section class="pdf-item">
    <header class="header">
      <span class="title">专精特新小巨人测评报告</span>
      <!-- <span class="name">汉唐信通（北京）咨询股份有限公司</span> -->
      <span class="name">{{ companyName }}</span>
    </header>
    <div class="content">
      <slot></slot>
    </div>
    <footer v-if="page" class="footer">{{ page }}</footer>
  </section>
</template>

<script>
export default {
  props: ['page', 'companyName'],
  data() {
    return {}
  },
}
</script>

<style lang="less" scoped>
.pdf-item {
  position: relative;
  min-height: 1200px;
  box-sizing: border-box;
  border: 1px solid #eee;
  overflow: hidden;
  padding-bottom: 50px;
  .header {
    height: 60px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 14px;
    color: #666;
    padding: 0 20px;
  }
  .content {
    padding: 10px 40px;
    box-sizing: border-box;
  }
  .footer {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 50px;
    padding-left: 20px;
    line-height: 50px;
    font-weight: 600;
    color: #333333;
  }
}
</style>
